module.exports = __webpack_public_path__ + "img/cloud-bolt-sun.007bf8ac.svg";